import * as Yup from 'yup';

export const editSubAgencyValidationSchema = Yup.object().shape({
    agency: Yup.object().shape({
        name: Yup.string()
            .required('Agency name is required')
            .min(2, 'Agency name must be at least 2 characters'),
        email: Yup.string()
            .email('Invalid email format')
            .required('Agency email is required'),
        phone: Yup.string()
            .required('Agency phone is required')
            .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number format'),
        markup: Yup.number()
            .required('Markup is required')
            .min(0, 'Markup cannot be negative'),
        balance: Yup.number()
            .min(0, 'Balance cannot be negative'),
        up_limit: Yup.number()
            .min(0, 'Up limit cannot be negative'),
        country_id: Yup.string().required('Country is required'),
        state_id: Yup.string().nullable(),
        city_id: Yup.string().nullable(),
        address: Yup.object().shape({
            address: Yup.string().required('Address is required'),
            country_id: Yup.string().required('Country is required'),
            state_id: Yup.string().nullable(),
            city_id: Yup.string().nullable(),
            zip_code: Yup.string().nullable().matches(/^[0-9-]*$/, 'Invalid zip code format'),
        }),
        details: Yup.object().shape({
            website: Yup.string().nullable().url('Invalid website URL'),
        }),
    }),
}); 